import React, { useState } from "react";
import axios from "axios";
import AvailabilityRow from "./AvailabilityRow";
import Swal from "sweetalert2";
import API_BASE_URL from "../config";

axios.defaults.withCredentials = true;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;

export const showToast = (title, icon = "success") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title,
  });
};

export default function OverrideModal({ userId, open, onClose }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [available, setAvailable] = useState(true);
  const [availability, setAvailability] = useState([]);

  const today = new Date().toISOString().split("T")[0];

  const saveOverride = async () => {
    try {
      await axios.put(
        `${API_BASE_URL}/user/${userId}/availability-overrides`,
        {
          overrides: [
            {
              startDate,
              endDate,
              available,
              hours: available ? availability : [],
            },
          ],
        }
      );
      onClose();
    } catch (error) {
      console.error("Failed to save override", error);
      showToast("There was an error saving the override.", "error");
    }
  };

  if (!open) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content aaom">
          <div className="modal-header">
            <h5 className="modal-title">Add Availability Override</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  min={today}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  min={startDate || today}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="availableSwitch"
                checked={available}
                onChange={() => setAvailable(!available)}
              />
              <label className="form-check-label" htmlFor="availableSwitch">
                {available ? "Available" : "Unavailable"}
              </label>
            </div>

            {available && (
              <div className="border p-3 rounded bg-light">
                <AvailabilityRow
                  day="Override"
                  availability={availability}
                  setAvailability={setAvailability}
                />
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-success" onClick={saveOverride}>
              Save Override
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
